module.exports = __webpack_public_path__ + "static/media/na.00acca12.png";